(function(){
    'use strict';
    angular.module('Services').factory('ObjectHelpersService', ObjectHelpersService);
    ObjectHelpersService.$inject = [];

    function ObjectHelpersService() {
        return {
            isObjectEmpty: (object) => {
                return Object.entries(object).length === 0;
            }
        }
    }
})()



// WEBPACK FOOTER //
// ./js/services/Utilities/ObjectHelpersService.js